export class Message {
  public static readonly SAVE_SUCCESS = 'บันทึกข้อมูลเรียบร้อยแล้ว';
  public static readonly SAVE_FAIL = 'บันทึกข้อมูลไม่สำเร็จ';
  public static readonly SAVE_FAIL_INVALID_FORM = 'กรุณากรอกข้อมูลให้ครบถ้วน';
}
